export default __webpack_public_path__ + "static/media/thumbnail-11.a06792ea.jpg";